import store from '@/store/'

// eslint-disable-next-line no-unused-vars
export default function whitelabelApp({ from, next, router, to }) {
  if (!store.getters['user/apps'].id) {
    return router.push({ name: 'dashboard' })
  }

  return next()
}
